export enum RegistrationType {
    DEFAULT = "",
    APP_SOLUTION = "appSolution",
    URL_PARAMETERS = "urlParameters",
    NO_DELIVERY = "noDelivery",
}
